import { ImageProps } from './Types'
import { extractPublicIdFromUrl, useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import React, { useEffect, useMemo, useState } from 'react'
import { fill } from '@cloudinary/url-gen/actions/resize'
import { Delivery } from '@cloudinary/url-gen/actions'
import Styles from 'screens/ContentPlan/CoverImage/CoverImage.module.scss'
import cx from 'classnames'
import { LoadingShimmerer as BaseLoadingShimmerer } from 'components/LoadingShimmerer/LoadingShimmerer'

export const LoadingShimmerer = () => <BaseLoadingShimmerer className={Styles.imageShimmer} />

export const CoverImage = ({ src, alt, width = 48, height = 48, ...props }: ImageProps) => {
  const cloudinary = useCloudinary()
  const [loading, setLoading] = useState(true)

  const coverImage = useMemo(() => {
    const id = extractPublicIdFromUrl(src)

    const img = cloudinary?.image(id)

    if (!img) return src

    const dpr = Math.min(typeof window === 'undefined' ? 1 : window.devicePixelRatio || 1, 3)

    return img
      .resize(fill().width(width).height(height))
      .delivery(Delivery.quality('auto'))
      .delivery(Delivery.dpr(dpr))
      .toURL()
  }, [src, cloudinary, width, height])

  useEffect(() => {
    setLoading(true)
    const img = new Image()
    img.src = coverImage
    img.onload = () => {
      setLoading(false)
    }
    img.onerror = () => {
      setLoading(false)
    }
  }, [coverImage])

  return (
    <div className={Styles.coverImage}>
      <img alt={alt} src={coverImage} {...props} className={cx(Styles.image, { [Styles.loading]: loading })} />
      {loading && <LoadingShimmerer />}
    </div>
  )
}
